import {Euler, Vector3, Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR: 2,
};
// Here we split by Artists Names
//ChatRoom01
//ScreenStageLeft
const CameraLocationsDB = [
    {
        cameraLocationId: 'AW',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Abby Wheeler',
        ObjectId:null,
    },
    {
        cameraLocationId: 'AHW',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Alex Haydn-Williams',
        ObjectId:null,
    },
    {
        cameraLocationId: 'AS',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Amelie Slack',
        ObjectId:null,
    },
    {
        cameraLocationId: 'AB',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Amy Bottomley',
        ObjectId:null,
    },
    {
        cameraLocationId: 'AD',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Anja Diel',
        ObjectId:null,
    },
    {
        cameraLocationId: 'AC',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Aoife Clark',
        ObjectId:null,
    },
    {
        cameraLocationId: 'BSL',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Blanca Schofield Legorburo',
        ObjectId:null,
    },
    {
        cameraLocationId: 'CM',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Charlotte McDonald',
        ObjectId:null,
    },
    {
        //The camera looks at paintingId: R1W01
        cameraLocationId: 'EC1',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Ella Curry - Room 1',
        ObjectId:null,
    },
    {
        //This cameral looks at paintingId: R2W01
        cameraLocationId: 'EC2',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Ella Curry - Room 2',
        ObjectId:null,
    },
    {
        cameraLocationId: 'EN',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Ella Nowicki',
        ObjectId:null,
    },
    {
        //This camera can either look at the one with the sprite R1S05, or all in general R1S04, R1S05, and R1S06
        cameraLocationId: 'FA1',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Fern Acheson - Room 1',
        ObjectId:null,
    },
    {
        //This camera looks at this painting / or two paintings if you find it better: 'R2N01'/'R2N02'
        cameraLocationId: 'FA2',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Fern Acheson - Room 2',
        ObjectId:null,
    },
    {
        cameraLocationId: 'IW',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Issie Weir',
        ObjectId:null,
    },
    {
        cameraLocationId: 'JP',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Juliet Patrick',
        ObjectId:null,
    },
    {
        cameraLocationId: 'JO',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Juliette Odolant',
        ObjectId:null,
    },
    {
        cameraLocationId: 'KG',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Katie Grenville',
        ObjectId:null,
    },
    {
        //This camera needs to look at 'R1W02'
        cameraLocationId: 'NY1',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Nik Yazikov - Room 1',
        ObjectId:null,
    },
    {
        //This camera looks at 'R2E03'
        cameraLocationId: 'NY2',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Nik Yazikov - Room 2',
        ObjectId:null,
    },
    {
        cameraLocationId: 'SB',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Sieve Bonaiuti',
        ObjectId:null,
    },
    {
        cameraLocationId: 'SOB',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Sophie Beckingham',
        ObjectId:null,
    },
    {
        cameraLocationId: 'SN',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Sophie Neville',
        ObjectId:null,
    },
    {
        cameraLocationId: 'TB',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Tabitha Blackburn',
        ObjectId:null,
    },
    {
        //This camera location looks at the video: R1N01
        cameraLocationId: 'TA1',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Toby Ashworth - Video',
        ObjectId:null,
    },
    {
        //The camera looks at this paintingId: R2S05
        cameraLocationId: 'TA2',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Toby Ashworth - Painting',
        ObjectId:null,
    },
    // {
    //     cameraLocationId: '',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: '',
    //     ObjectId:null,
    // },
    // {
    //     cameraLocationId: '',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: '',
    //     ObjectId:null,
    // },
    // {
    //     cameraLocationId: '',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: '',
    //     ObjectId:null,
    // },
];

export {CameraLocationsDB, FLOOR_NUMBER};
